module.exports = __webpack_public_path__ + "static/media/file-step.88625851.svg";